// DEPENDENCIES
import React, { Component } from 'react';
import Modal from 'react-modal';
import SVGInline from 'react-svg-inline'

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {clientMedia, connection} from '../../Config/Settings';


// INNER IMPORTS

// actions
import { loginCall, closeLoginModal, openSignupModal, openTempUserModal, closeTempUserModal } from '../../Actions/users';
import { openPayingMethodsModal } from '../../Actions/main';

// svgs
import closeCrossSVG from '../inlineSVGs/closeCrossSVG';

// styles
import './Login.css';
import { AnalyticsService } from "../../Services";

class LoginModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    // Every time the user changes the email/password field, the state changes accordingly
    updateEmail(event) {
        this.setState({
            email: event.target.value.toLowerCase()
        })
    }
    updatePassword(event) {
        this.setState({
            password: event.target.value
        })
    }

    handleLoginClick(e) {

        e.preventDefault();
        let pinDataWaiting = this.props.pinDataWaiting;
        // let filesWaiting = this.props.filesWaiting;
        this.props.loginCall(this.state).then(data => {

            AnalyticsService.sendEvent(AnalyticsService.events.LOG_IN, 'email', null, { type: 'email'});

            if (data && data.isTempUser) {
                this.props.closeLoginModal();
                this.props.openTempUserModal();
                return;
            }

            // if login was called as part of submitting a pin
            if (pinDataWaiting) {
                this.props.closeLoginModal();
                this.props.openPayingMethodsModal();
                // this.props.savePin(this.props.token, pinDataWaiting, filesWaiting);
            }

            this.props.closeLoginModal();
        }).catch(err => {
            // TODO: handle errors on login
        });
    }

    onForgotPassword() {
        this.props.closeLoginModal();
        // browserHistory.push('/forgot-password');
        window.location.href = `${connection().clientUrl}/forgot-password`
    }

    handleSocialLogin(type) {
        AnalyticsService.sendEvent(AnalyticsService.events.LOG_IN, type, null, { type });

        window.location.href = `${connection().serverUrl}/auth/${type}`
    }

    // Oh...so you're a mugic!
    render() {
        return (
            <div className="login">
                <Modal
                    isOpen={this.props.isLoginModalOpen}
                    contentLabel="Login"
                    className="loginModal rtl"
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)'
                        }}}
                >
                    <div onClick={this.props.closeLoginModal} >
                        <SVGInline className="closeButton" svg={closeCrossSVG} component="i"/>
                    </div>
                    <div className="content">
                        <div className="leftPart">
                            <img className="loginBackImg1" src={`${clientMedia()}/img/backgroundAddons/login1.png`} role="presentation" alt="login-icon"/>
                        </div>
                        <div className="rightPart rtl">
                            <div className="title">הו... אז אתם Mugics!</div>
                            <div className="form">
                                <form onSubmit={(e) => this.handleLoginClick(e)}>
                                    <input type="text" id="email" placeholder="מייל" onChange={this.updateEmail.bind(this)}/>
                                    <input type="password" id="password" placeholder="סיסמא" onChange={this.updatePassword.bind(this)}/>
                                    <div className="forgot" onClick={() => this.onForgotPassword()}>שכחתי סיסמא</div>
                                    <div className="message">{this.props.message}</div>
                                    <button type="submit" className="login-button" onClick={(e) => this.handleLoginClick(e)}>התחבר</button>
                                </form>
                            </div>
                            <div className="line">
                                <div className="connectWith">או התחברו דרך</div>
                            </div>
                            <div className="connectWithButtons">
                                <div className="facebookButton" onClick={()=> this.handleSocialLogin('facebook')}>FACEBOOK</div>
                                <div className="googleButton" onClick={()=> this.handleSocialLogin('google')}>GOOGLE</div>
                            </div>
                            <div className="signupText">
                                <div className="signup">אין לך חשבון?</div>
                                <div className="signupnow" onClick={() => this.props.openSignupModal()}>להרשמה</div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

LoginModal.propTypes = {
    // state props
    isLoginModalOpen: PropTypes.bool,
    token: PropTypes.string,
    pinDataWaiting: PropTypes.object,
    message: PropTypes.string,
    programActivated: PropTypes.bool,

    // actions
    // savePin: PropTypes.func,
    openPayingMethodsModal: PropTypes.func,
    loginCall: PropTypes.func,
    closeLoginModal: PropTypes.func,
    openSignupModal: PropTypes.func,
    openTempUserModal: PropTypes.func,
    closeTempUserModal: PropTypes.func
};

const mapStateToProps = state => ({
    message: state.users.loginMessage,
    pinDataWaiting: state.users.pinDataWaiting,
    // filesWaiting: state.users.filesWaiting,
    isLoginModalOpen: state.users.isLoginModalOpen,
    token: state.users.token,
    programActivated: state.users.programActivated
});

// connecting redux state to the component props
export const LoginModalContainer = connect(mapStateToProps, {
    loginCall,
    closeLoginModal,
    openPayingMethodsModal,
    openSignupModal,
    openTempUserModal,
    closeTempUserModal
})(LoginModal);

export default LoginModal;



// WEBPACK FOOTER //
// ./src/Components/Users/Login.js